/* eslint-disable @cspell/spellchecker */
import AutoScroll from 'embla-carousel-auto-scroll';
import Autoplay from 'embla-carousel-autoplay';
import React, { FC } from 'react';
import arcadiascienceCustomer from '../../../assets/images/customers/arcadiascience.svg';
import avsightCustomer from '../../../assets/images/customers/avsight.svg';
import butterflymxCustomer from '../../../assets/images/customers/butterflymx.svg';
import bvnkCustomer from '../../../assets/images/customers/bvnk.svg';
import capitalGurusCustomer from '../../../assets/images/customers/capitalgurus.svg';
import clarasysCustomer from '../../../assets/images/customers/clarasys.svg';
import codeforafricaCustomer from '../../../assets/images/customers/codeforafrica.svg';
import cognicianCustomer from '../../../assets/images/customers/cognician.svg';
import enablemedicineCustomer from '../../../assets/images/customers/enablemedicine.svg';
import endeavorCustomer from '../../../assets/images/customers/endeavor.svg';
import fitbodCustomer from '../../../assets/images/customers/fitbod.svg';
import healthatomCustomer from '../../../assets/images/customers/healthatom.svg';
import heygenCustomer from '../../../assets/images/customers/heygen.svg';
import patientknowsbestCustomer from '../../../assets/images/customers/patientknowsbest.svg';
import podiumCustomer from '../../../assets/images/customers/podium.svg';
import sesolaborCustomer from '../../../assets/images/customers/sesolabor.svg';
import swiftnavCustomer from '../../../assets/images/customers/swiftnav.svg';
import swiggyCustomer from '../../../assets/images/customers/swiggy.svg';
import tesorioCustomer from '../../../assets/images/customers/tesorio.svg';
import thevetspetsCustomer from '../../../assets/images/customers/thevetspets.svg';
import tremendousCustomer from '../../../assets/images/customers/tremendous.svg';
import triumgroupCustomer from '../../../assets/images/customers/triumgroup.svg';
import truecarCustomer from '../../../assets/images/customers/truecar.svg';
import userinterviewsCustomer from '../../../assets/images/customers/userinterviews.svg';
import dashAiUseCase1 from '../../../assets/images/dash_ai_use_case_1.webp';
import dashAiUseCase2 from '../../../assets/images/dash_ai_use_case_2.webp';
import dashAiUseCase3 from '../../../assets/images/dash_ai_use_case_3.webp';
import { privacyPolicy, termsOfService } from '../../../components/links/links';
import { BookCallStep } from '../../../components/onboarding/steps/BookCallStep/BookCallStep';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '../../../components/shadcn/lib/components/carousel';

export const AuthContainer: FC<{
  unauthorized: boolean;
}> = ({ children, unauthorized }) => {
  return (
    <div className="h-screen cursor-default flex">
      <div className="w-full sm:w-1/2 bg-cloud-10 relative flex justify-center items-center">
        <div>{unauthorized ? <BookCallStep /> : children}</div>
        <div className="absolute bottom-4 text-xs sm:text-sm text-center m-1">
          By continuing, you acknowledge that you have read, and agree to our{' '}
          <a
            className="font-medium text-amethys-10 hover:text-amethys-20"
            href={termsOfService}
            rel="noreferrer"
            target="_blank"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            className="font-medium text-amethys-10 hover:text-amethys-20"
            href={privacyPolicy}
            rel="noreferrer"
            target="_blank"
          >
            Privacy Policy.
          </a>
        </div>
      </div>

      <div className="w-1/2 pt-6 overflow-y-auto hidden sm:flex flex-col justify-evenly items-center bg-gradient-to-b from-amethys-10 to-white">
        <Carousel
          className="w-[300px] md:w-[380px] lg:w-[450px] 2xl:w-[580px]"
          opts={{
            loop: true,
          }}
          plugins={[
            // eslint-disable-next-line new-cap
            Autoplay({
              delay: 3000,
              stopOnInteraction: false,
            }),
          ]}
        >
          <CarouselContent>
            <CarouselItem className="basis-1/24">
              <img
                className="w-[300px] md:w-[380px] lg:w-[450px] 2xl:w-[580px]"
                src={dashAiUseCase1}
              />
            </CarouselItem>
            <CarouselItem className="basis-1/24">
              <img
                className="w-[300px] md:w-[380px] lg:w-[450px] 2xl:w-[580px]"
                src={dashAiUseCase2}
              />
            </CarouselItem>
            <CarouselItem className="basis-1/24">
              <img
                className="w-[300px] md:w-[380px] lg:w-[450px] 2xl:w-[580px]"
                src={dashAiUseCase3}
              />
            </CarouselItem>
          </CarouselContent>
        </Carousel>
        <div className="max-w-full flex flex-col gap-4">
          <div className="text-center font-medium 2xl:text-xl">
            Trusted by Leaders & Innovators
          </div>
          <Carousel
            opts={{
              loop: true,
            }}
            plugins={[
              // eslint-disable-next-line new-cap
              AutoScroll({
                speed: 0.7,
                stopOnInteraction: false,
              }),
            ]}
          >
            <CarouselContent className="flex items-center">
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={podiumCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={swiggyCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={truecarCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img
                  className="mx-6"
                  src={userinterviewsCustomer}
                  width={200}
                />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={butterflymxCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={clarasysCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={heygenCustomer} width={140} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={endeavorCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img
                  className="mx-6"
                  src={patientknowsbestCustomer}
                  width={250}
                />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={healthatomCustomer} width={170} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={tremendousCustomer} width={200} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={capitalGurusCustomer} width={200} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={triumgroupCustomer} width={120} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={sesolaborCustomer} width={100} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={cognicianCustomer} width={160} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={swiftnavCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img
                  className="mx-6"
                  src={arcadiascienceCustomer}
                  width={160}
                />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={bvnkCustomer} width={100} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={tesorioCustomer} width={130} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img
                  className="mx-6"
                  src={enablemedicineCustomer}
                  width={200}
                />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={fitbodCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={avsightCustomer} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={codeforafricaCustomer} width={90} />
              </CarouselItem>
              <CarouselItem className="basis-1/24">
                <img className="mx-6" src={thevetspetsCustomer} />
              </CarouselItem>
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </div>
  );
};
